import { baseApi } from "./baseApi";

interface SidebarStats {
  services_total: number;
  incidents_open: number;
}

/**
 * Stats del sidebar — hoy se re-llama en cada navegación porque cada `<Link>`
 * dispara un re-mount de Sidebar. Con RTK Query + cache compartido + `keepUnusedDataFor`,
 * el sidebar consulta UNA vez cada 60s, no en cada click.
 */
export const statsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSidebarStats: builder.query<SidebarStats, void>({
      query: () => "/v1/stats/sidebar",
      providesTags: [{ type: "Stats", id: "sidebar" }],
      // Mantenemos el cache 60s aunque ningún componente esté suscripto.
      // Esto evita que un re-mount rápido tras navegar dispare otro fetch.
      keepUnusedDataFor: 60,
    }),
  }),
  overrideExisting: false,
});

export const { useGetSidebarStatsQuery } = statsApi;
